import {
  CARDIAC_IMPRESSION_OPTIONS,
  CARDIAC_INDETERMINATE_FOR,
  CARDIAC_IVC_IMPRESSION,
  cardiacFindings,
  indeterminateFor,
} from "../groups/cardiac";
import { LUNG_FINDINGS } from "../groups/thoracic";
import {
  dropdown,
  multi,
  OTHER,
  option,
  type UsWorksheetDefinition,
} from "../us-fields";
import { CARDIAC_INDICATIONS } from "./us-cardiac";

export const US_CARDIAC_THORACIC: UsWorksheetDefinition = {
  examType: "us_cardiac_thoracic",
  version: 1,
  indications: [
    ...CARDIAC_INDICATIONS,
    option("absent_breath_sounds", "Absent breath sounds"),
    option("wheezing", "Wheezing"),
    option("hypoxia", "Hypoxia"),
    option("cough", "Cough"),
    option("fever", "Fever"),
  ],
  otherIndication: true,
  sections: [
    {
      id: "cardiac_findings",
      label: "Cardiac findings",
      role: "findings",
      technicallyLimited: true,
      fields: cardiacFindings(),
    },
    {
      id: "thoracic_lung",
      label: "lung",
      role: "findings",
      technicallyLimited: true,
      repeatPerSide: ["right", "left"],
      fields: LUNG_FINDINGS,
    },
    {
      id: "impression",
      label: "Impressions",
      role: "impression",
      fields: [
        multi("cardiac.impression", "Cardiac", [
          CARDIAC_IMPRESSION_OPTIONS.normal,
          CARDIAC_IMPRESSION_OPTIONS.systolicDysfunction,
          CARDIAC_IMPRESSION_OPTIONS.effusionWithoutTamponade,
          CARDIAC_IMPRESSION_OPTIONS.tamponade,
          CARDIAC_IMPRESSION_OPTIONS.rvStrain,
          indeterminateFor([
            ...CARDIAC_INDETERMINATE_FOR,
            option("pneumothorax", "pneumothorax"),
            option("pulmonary_edema", "Pulmonary edema"),
            option("pleural_effusion", "Pleural effusion"),
            option("pneumonia", "Pneumonia"),
          ]),
          OTHER,
        ]),
        multi("thoracic.impression", "Thoracic", [
          option("normal_thoracic", "Normal thoracic POCUS"),
          option("pulmonary_edema", "Pulmonary edema"),
          option("pneumothorax", "pneumothorax", { sided: true }),
          option("pleural_effusion", "pleural effusion", { sided: true }),
          option("pneumonia", "Pneumonia, location(s)", {
            reveals: [
              dropdown("thoracic.pneumonia_location", "Pneumonia location(s)", [
                option("not_applicable", "N/A"),
                option("right_anterior_superior", "Right anterior-superior"),
                option("right_anterior_inferior", "Right anterior-inferior"),
                option("right_lateral_superior", "Right lateral-superior"),
                option("right_lateral_inferior", "Right lateral inferior"),
                option("left_anterior_superior", "Left anterior-superior"),
                option("left_anterior_inferior", "Left anterior-inferior"),
                option("left_lateral_superior", "left lateral-superior"),
              ]),
            ],
          }),
          OTHER,
        ]),
        CARDIAC_IVC_IMPRESSION,
      ],
    },
  ],
  normalImpressions: [
    { sectionId: "impression", value: "normal_cardiac" },
    { sectionId: "impression", value: "normal_thoracic" },
  ],
  billing: {
    codes: [
      { cpt: "93308", label: "Echocardiography, limited", preTick: true },
      { cpt: "76604", label: "Chest ultrasound" },
    ],
  },
};
